import { IEvent, IInterWindowEvent } from '@samc/common';

export class ItemSelectedEvent implements IInterWindowEvent {
  static eventName: 'ItemSelectedEvent' = 'ItemSelectedEvent';
  public name: string = ItemSelectedEvent.eventName;
  constructor(public srcWindowId: string, public destWindowId: string, public itemId: string, public openInNewTab = false, public payload?: any) { }
}
